// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet: (u.indexOf('windows') != -1 && u.indexOf('touch') != -1)
      || u.indexOf('ipad') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') == -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1)
      || u.indexOf('kindle') != -1
      || u.indexOf('silk') != -1
      || u.indexOf('playbook') != -1,
    Mobile: (u.indexOf('windows') != -1 && u.indexOf('phone') != -1)
      || u.indexOf('iphone') != -1
      || u.indexOf('ipod') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') != -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1)
      || u.indexOf('blackberry') != -1
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 600;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  setHeader();
  // killClick()
  // startScroll()
  if (!$('#wrapper').hasClass('home')) {}
  // ///////////
  if (_ua.Tablet || _ua.Mobile) {} else {}
  // ///////////
  if (!_ua.Mobile) {}
});
$(window).on('load', function () {
  heightLineGroup();
  svg4everybody();
  setLoaded();
  judgeWinSize();
  setWay();
  setHeader();
  setMainMenu();
  setLinkSelect();
  if ($('#wrapper').hasClass('home')) {} else {}
  if (!_ua.Mobile) {
  } else {}
});

// Fancyboxオプション
function setFancy () {
  $('[data-fancybox]').fancybox({
    // オプションを下記に記載していきます
    animationEffect: 'zoom-in-out', // アニメーションをズームインアウトに
    loop: true, // 複数画像表示時に最初と最後をループさせる
    // toolbar: false, // ツールバーの非表示
    // smallBtn: true, // 小さいCloseボタン利用する
    iframe: { // iframe 関連の処理
      preload: false // iframeのプリロードをしない
    }
  });
}

// セレクトでリンク
function setLinkSelect () {
  var selected = $('.linkSelect');
  selected.on('change', function () {
    window.location.href = selected.val();
  });
}

// /////TOP KV制御
function setMainVis () {
  setTimeout(function () {
    $('#kvVideo video').get(0).play();
  }, 2000);
}

// ///////右クリック禁止
function killClick () {
  $(document).on('contextmenu', function (e) {
    return false;
  });
}

// ///////ヘッダー制御
function setHeader () {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader () {
    if ($('#wrapper').hasClass('home')) {
      h = $('#mainVis').height();
    }else {
      h = $('header').height();
    }
    baseHeight = h;
    if ($(this).scrollTop() <= baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    }else if ($(this).scrollTop() > baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
  }
}

// //////////////////////////メインメニュー
function setMainMenu () {
  var current_scrollY;
  $('#burgerMenu').on('click', function () {
    if (!$(this).hasClass('active')) {
      openFnc();
    }else {
      closeFnc();
    }
  });

  $('#clickBlocker').on('click', function () {
    closeFnc();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });

  function openFnc () {
    current_scrollY = $(window).scrollTop();
    $('#burgerMenu').addClass('active');
    $('#wrapper').addClass('menuOpen');
    $('#outerMenu').css('top', -(current_scrollY));
    setTimeout(function () {
      $('html, body').prop({
        scrollTop: 0
      });
    }, 100);
  }

  function closeFnc () {
    $('#burgerMenu').removeClass('active');
    $('#outerMenu').css('top', '');
    $('#wrapper').removeClass('menuOpen');
    $('html, body').prop({
      scrollTop: current_scrollY
    });
  }
}

// ////////////////////////////スライダー
function setCarousel01 () {
  var target = '.carouselStyle_01';
  $(target).each(function () {
    var owl = $(this).find('.screen');
    var baseCount = $(this).find('.screen>.carouselItem').length + 1;
    if (baseCount > 2) {
      // owl.addClass('owlCarousel')
      owl.owlCarousel({
        loop: true,
        // margin: 30,
        // slideSpeed: 3000,
        // paginationSpeed: 1000,
        // items: 3,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        dots: true,
        nav: false,
        // animateOut: 'fadeOut',
        mouseDrag: true,
        touchDrag: true,
        URLhashListener: false,
        // slideBy: 1,
        responsive: {
          0: {
            margin: 15,
            items: 1,
            stagePadding: 35
          },
          1000: {
            margin: 30,
            items: 1,
            dotsEach: 1,
            // slideBy: 1,
            stagePadding: 300
          }
        }
      // startPosition: 'URLHash'
      // slideBy:5,
      });
    } else {
      owl.removeClass('owl-carousel');
    }
    owl.on('changed.owl.carousel', function (e) {
      owl.trigger('stop.owl.autoplay');
      owl.trigger('play.owl.autoplay');
    });
  });
}

// ////////////ウィンドウサイズを判別
function judgeWinSize () {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// //////////////////////////////ロード完了
function setLoaded () {
  $('#wrapper').addClass('loaded');
}

// ///////waypoint
function setWay () {
  $('.way,.setAnimation,#bgTx>div,.nullWay').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.shuffle').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
      // var container = $(this.element)
      activePoint.shuffleLetters();
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.scaleway,.nullWay,.ttlStyle_05,.fade_01,.fade_02').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });
}

// /////////////////////////////スムーススクロール
function setScroll () {
  $('a[href^="#"]').click(function () {
    if (!$(this).hasClass('crNav')) {
      // スクロールの速度
      var speed = 400; // ミリ秒
      // アンカーの値取得
      var href = $(this).attr('href');
      // 移動先を取得
      var target = $(href == '#' || href == '' ? 'html' : href);
      // 移動先を数値で取得
      if (!_ua.Mobile) {
        var position = target.offset().top;
      } else {
        var position = target.offset().top - $('header').height();
      }
      if ($(this).hasClass('unqNav') && $('#wrapper').hasClass('setSp')) {
        if ($(this).hasClass('aboutPos')) {
          position = aboutPos;
        }else {
          position = missionPos;
        }
        closeFnc(position);
        return false;
      } else {
        // スムーススクロール
        $('body,html').animate({
          scrollTop: position
        }, speed, 'swing');
        return false;
      }
    }
  });
}

function startScroll () {
  setMrg = $('header').height() + 50;
  var timer = false;
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function () {
    var hashID = $(location).attr('hash');
    if (hashID) {
      var winW = $(window).width();
      if (winW > breakNum) {
        unqPc();
      } else {
        unqSp();
      }

      var timer = false;
      var currentWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        if (currentWidth == window.innerWidth) {
          return;
        }
        currentWidth = window.innerWidth;
        if (timer !== false) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          winW = $(window).width();
          if (winW > breakNum) {
            unqPc();
          } else {}
        }, 200);
      });

      function unqPc () {
        var speed = 400; // ミリ秒
        var href = hashID;
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = target.offset().top - setMrg;
        $('body,html').animate({
          scrollTop: position
        }, speed, 'swing');
      }

      function unqSp () {
        var href = hashID;
        var target = $(href == '#' || href == '' ? 'html' : href);
        console.log(target);
        $('#myPageNav').hide();
        $('.mypageCont').removeClass('show');
        $(target).addClass('show');
        $('.mypageBack').show();
        $('html, body').prop({
          scrollTop: 0
        });
      }
    }
  }, 10);
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup () {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    setAutoHeight('.setH_01');
  // setAutoHeight(".setH_01 .summary",3)
  } else {
    $('.setH_01').attr('style', '');
  // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight (target, count) {
  $(target).tile(count);
}

function startResize () {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
